//vista donde se muestran todos los accesos de un ticket
import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Alert, CircularProgress
} from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import {AccessTime, ExitToApp, MeetingRoom, Info} from '@mui/icons-material';
import moment from 'moment';
import { api } from '../../services/api';
import { config } from '../../services/config';

const apiOrigin = config.URL_API;

const Accesos = () => {
  const { id, idticket } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accesos, setAccesos] = useState([]);
  const [ticketInfo, setTicketInfo] = useState(null);


  useEffect(() => {
    const fetchAccesos = async () => {
      try {
        setLoading(true);
        const response = await api.accesos.getTicketAccesos(id, idticket);

        if (response.status === "success") {
          setAccesos(response.data.accesos);
          setTicketInfo(response.data.ticket);
        } else {
          setError("Error al cargar los accesos del ticket");
        }
      } catch (err) {
        console.error("Error al obtener accesos:", err);
        setError("No se pudieron cargar los datos de accesos");
      } finally {
        setLoading(false);
      }
    };

    fetchAccesos();
  }, [id, idticket]);

  const routeImage = `${apiOrigin}/static/eventos/tickets/ticket${idticket}.png`;

  const imageStyle = {
    width: window.innerWidth > 880 ? "400px" : "100px"
  }

  const getEstadoChip = (evento, ingreso) => {
    const chipStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '16px',
      padding: '4px 10px',
      fontSize: '14px',
      fontWeight: '500'
    };

    let icon, chipColor, borderColor, label, bgColor;

    if (evento === "Ingreso Ok") {
    icon = <MeetingRoom fontSize="small" style={{ transform: 'scaleX(-1)' }} />;
    chipColor = "#216735";
    borderColor = "#B6FECB";
    bgColor = "#B6FECB";
    label = "Ingreso";
  } else if (evento === "Intento") {
    icon = <Info fontSize="small" />;
    chipColor = "#636363";
    borderColor = "#E0E0E0";
    bgColor = "#F5F5F5";
    label = "Intento de Escaneo";
  } else if (evento === "Salida Definitiva") {
    icon = <ExitToApp fontSize="small" />;
    chipColor = "#8C1C13";
    borderColor = "#F8C6C1";
    bgColor = "#F8C6C1";
    label = "Salida Definitiva";
  } else if (evento === "Salida Temporal") {
    icon = <ExitToApp fontSize="small" />;
    chipColor = "#835C00";
    borderColor = "#FFE69C";
    bgColor = "#FFE69C";
    label = "Salida Temporal";
  } else {
    icon = <AccessTime fontSize="small" />;
    chipColor = "#757575";
    borderColor = "#e0e0e0";
    bgColor = "#F5F5F5";
    label = evento;
  }

    return (
      <span style={{ 
      ...chipStyle, 
      color: chipColor, 
      borderColor: borderColor,
      backgroundColor: bgColor,
      paddingLeft: '6px',
      paddingRight: '10px'
    }}>
      <span style={{ marginRight: '6px', display: 'flex', alignItems: 'center' }}>{icon}</span>
      <span>{label}</span>
    </span>
    );
  };

  const getUserAvatar = (usuario) => {
    if (!usuario || !usuario.nombre) return null;

    const initials = usuario.nombre.charAt(0) + (usuario.apellido ? usuario.apellido.charAt(0) : '');

    const avatarStyle = {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      backgroundColor: '#3659E3',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      marginRight: '8px'
    };

    return (
      <div style={avatarStyle}>
        {initials}
      </div>
    );
  };

  return (
    <div className="container-fluid" style={{ width: "100%", padding: "30px", marginBottom: "40px", backgroundColor: 'rgb(249, 250, 251)', borderTop: "1px solid rgb(228, 228, 231)" }}>
      {ticketInfo && (
        <div className="mb-4" style={{ padding: "10px 40px", backgroundColor: "#fff", borderRadius: "8px", border: "1px solid rgb(228, 228, 231)", }}>
          <div className='d-flex flex-row justify-content-between align-items-center my-3'>
            <p style={{ fontSize: "18px", fontWeight: "600", marginBottom: "0", color: "#5656ff" }}>
              Información del Ticket #{ticketInfo.id}
            </p>
            <div style={{ textAlign: "right" }}>
              <span style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: '10px',
                fontSize: '14px',
                fontWeight: '600',
                backgroundColor: ticketInfo.consumido ? '#F8C6C1' : '#B6FECB',
                color: ticketInfo.consumido ? '#8C1C13' : '#216735'
              }}>
                {ticketInfo.consumido ? "Consumido" : "Disponible"}
              </span>
            </div>
          </div>

          <div>
            <div style={{ borderRadius: "10px", border: "1px solid #e4e4e7", }}>
              <div className='d-flex justify-content-center'>
                <img src={routeImage} alt='Imagen del ticket' style={imageStyle} />
              </div>
            </div>
          </div>

          <div className="row my-4">
            <div className="col-md-6">
              <p className='mb-0' style={{ fontWeight: "400", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>
                Nombre y Apellido
              </p>
              <p className='mb-0' style={{ fontWeight: "500" }}>{ticketInfo?.nombre} {ticketInfo?.apellido}</p>
            </div>
            <div className="col-md-6">
              <p className='mb-0' style={{ fontWeight: "400", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>
                Tarifa
              </p>
              <p className='mb-0' style={{ fontWeight: "500" }}>{ticketInfo?.concepto}</p>
            </div>
          </div>

          <div style={{ padding: "20px 0", borderTop: "1px solid rgb(228, 228, 231)" }}>
            <p style={{ fontSize: "18px", color: "#5656ff", fontWeight: "600", marginBottom: "8px" }}>
              Accesos
            </p>

            {loading ? (
              <div className="d-flex justify-content-center flex-column align-items-center" style={{ padding: "40px 0" }}>
                <CircularProgress />
                <p style={{ marginTop: "16px" }}>
                  Cargando historial de accesos...
                </p>
              </div>
            ) : error ? (
              <Alert severity="error" style={{ margin: "16px 0" }}>{error}</Alert>
            ) : !accesos || accesos?.length === 0 ? (
              <Alert severity="info" style={{ margin: "16px 0" }}>
                Este ticket no tiene registros de accesos hasta el momento.
              </Alert>
            ) : (
              <TableContainer sx={{ border: "1px solid rgba(224, 224, 224, 1)", borderRadius: "4px" }}>
                <Table>
                  <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
                    <TableRow sx={{ borderColor: "#E6E6FF" }}>
                      <TableCell width="5%" sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>#</TableCell>
                      <TableCell width="20%" sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Fecha y Hora</TableCell>
                      <TableCell width="35%" sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Escaneado por</TableCell>
                      <TableCell width="25%" sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Estado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {accesos?.map((acceso) => (
                      <TableRow
                        key={acceso.id}
                        hover
                      >
                        <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>{acceso.id}</TableCell>
                        <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span>{moment(acceso.fecha).format('DD/MM/YYYY HH:mm')}</span>
                            </div>
                        </TableCell>
                        <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                          {acceso.usuario && acceso.usuario.nombre ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {getUserAvatar(acceso.usuario)}
                              <div>
                                <p style={{ margin: "0", fontSize: "16px" }}>
                                  {acceso.usuario.nombre} {acceso.usuario.apellido}
                                </p>
                                <p style={{ margin: "0", fontSize: "12px", color: "rgba(0,0,0,0.6)" }}>
                                  {acceso.usuario.email || ''}
                                </p>
                              </div>
                            </div>
                          ) : (
                            <p style={{ margin: "0", fontSize: "16px", color: "rgba(0,0,0,0.6)" }}>
                              Desconocido
                            </p>
                          )}
                        </TableCell>

                        <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {getEstadoChip(acceso.evento, acceso.ingreso)}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Accesos;